export const en = {
  PRODUCT_INFO_TITLE: 'Product Information',
  PRODUCT_INFO_DESCRIPTION: 'Details about the product.',
  DIMENSIONS_LABEL: 'Dimensions',
  MODEL_NUMBER_LABEL: 'Model Number',
  MATERIAL_TYPE_LABEL: 'Material Type',
  GLASS_TYPE_LABEL: 'Glass Type',
  ENERGY_RATING_LABEL: 'Energy Rating',
  MANUFACTURING_DATE_LABEL: 'Manufacturing Date',
  SERIAL_NUMBER_LABEL: 'Serial Number',
  INSTALLATION_STATUS_LABEL: 'Installation Status',
  WINDOW_TYPE_LABEL: 'Window Type',

  INSTALLATION_PROCESS_TITLE: 'Installation Process',
  INSTALLATION_PROCESS_DESCRIPTION: 'Details about the installation process.',
  SCHEDULED_DATE_LABEL: 'Scheduled Date',
  INSTALLER_LABEL: 'Installer',
  DURATION_LABEL: 'Duration',
  STATUS_LABEL: 'Status',
  TOOLS_REQUIRED_LABEL: 'Tools Required',
  INSTALLER_NAME_LABEL: 'Installer Name',
  TOOLS_NEEDED_LABEL: 'Tools Needed',
  INSTALLATION_NOTES_LABEL: 'Installation Notes',
  WINDOW_PHOTO_LABEL: 'Window Photo',
  INSTALLATION_PHOTOS_LABEL: 'Installation Photos',

  MAINTENANCE_LOG_TITLE: 'Maintenance Log',
  MAINTENANCE_LOG_DESCRIPTION: 'Details about maintenance activities.',
  LAST_SERVICE_LABEL: 'Last Service',
  SERVICE_TYPE_LABEL: 'Service Type',
  TECHNICIAN_LABEL: 'Technician',
  NEXT_SERVICE_DUE_LABEL: 'Next Service Due',

  START_INSTALLATION_TITLE: 'Start Installation',
  START_INSTALLATION_DESCRIPTION: 'Wizard to guide through the installation process.',
  INSTALLER_NAME_QUESTION: "What is the installer's name?",
  WINDOW_TYPE_QUESTION: 'What type of window is being installed?',
  TOOLS_NEEDED_QUESTION: 'What tools are needed for the installation?',
  INSTALLATION_NOTES_QUESTION: 'Any additional notes for the installation?',
  WINDOW_PHOTO_QUESTION: 'Please upload a photo of the window.',
  INSTALLATION_PHOTOS_QUESTION: 'Please upload photos of the installation process.',

  // Installation Wizard Questions
  SCHEDULED_DATE_QUESTION: 'When is the installation scheduled for?',
  INSTALLER_QUESTION: 'Who is the assigned installer?',
  INSTALLER_DASHBOARD: 'Installer Dashboard',

  // Installer Dashboard
  INSTALLER_LOADING: 'Loading your sites...',
  INSTALLER_ERROR_TITLE: 'Error Loading Sites',
  INSTALLER_TRY_AGAIN: 'Try Again',
  INSTALLER_PROJECT_INVITATIONS: 'Site Invitations',
  INSTALLER_NEW_PROJECT_INVITATION: 'New Site Invitation',
  INSTALLER_PROJECT_DEFAULT: 'Site',
  INSTALLER_ACCEPT: 'Accept',
  INSTALLER_REJECT: 'Reject',
  INSTALLER_RECENT_PROJECTS: 'Active Sites',
  INSTALLER_NO_RECENT_PROJECTS: 'No Recent Sites',
  INSTALLER_PROJECTS_APPEAR_MESSAGE: 'Your recent sites will appear here once you start working on them.',

  // Time formatting
  TIME_JUST_NOW: 'Just now',
  TIME_MINUTES_AGO: 'minutes ago',
  TIME_HOUR_AGO: '1 hour ago',
  TIME_HOURS_AGO: 'hours ago',
  TIME_YESTERDAY: 'Yesterday',
  TIME_DAYS_AGO: 'days ago',
  TIME_WEEKS_AGO: 'weeks ago',

  // Project Status
  STATUS_ACCEPTED: 'Accepted',
  STATUS_REJECTED: 'Rejected',
  STATUS_PENDING: 'Pending',
  STATUS_COMPLETED: 'Completed',
  STATUS_IN_PROGRESS: 'In Progress',
  STATUS_CANCELLED: 'Cancelled',
  DURATION_QUESTION: 'How long will the installation take?',
  STATUS_QUESTION: 'What is the current status of the installation?',
  TOOLS_REQUIRED_QUESTION: 'What tools are required?',

  // Status Options (for select)
  STATUS_DELAYED: 'Delayed',

  // Tool Options (for multiselect)
  TOOL_DRILL: 'Drill',
  TOOL_LEVEL: 'Level',
  TOOL_TAPE_MEASURE: 'Tape Measure',
  TOOL_SCREWDRIVER: 'Screwdriver',
  TOOL_CAULK_GUN: 'Caulk Gun',
  TOOL_SAFETY_GLASSES: 'Safety Glasses',
  TOOL_WORK_GLOVES: 'Work Gloves',

  // New Labels
  PRODUCT_DOCUMENTS_TITLE: 'Product Documents',
  PRODUCT_DOCUMENTS_DESCRIPTION: 'Documentation related to the product.',
  SCHEDA_TECNICA_LABEL: 'Technical Sheet',
  DICHIARAZIONE_SOSTANZE_PERICOLOSE_LABEL: 'Declaration of Hazardous Substances',
  DICHIARAZIONE_DI_PRESTAZIONE_LABEL: 'Declaration of Performance',

  CE_MARKING_TITLE: 'CE Marking',
  CE_MARKING_DESCRIPTION: 'CE Marking documentation.',
  MARCATURA_CE_LABEL: 'CE Marking',
  ETICHETTA_CE_LABEL: 'CE Label',

  MAINTENANCE_DOCUMENTS_TITLE: 'Maintenance Documents',
  MAINTENANCE_DOCUMENTS_DESCRIPTION: 'Documents related to maintenance.',
  MANUALE_DI_MANUTENZIONE_LABEL: 'Maintenance Manual',

  INSTALLATION_INFORMATION_TITLE: 'Installation Information',
  INSTALLATION_INFORMATION_DESCRIPTION: 'Details about the installation.',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_SX_LABEL: 'Secondary Joint Front Top Left',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_SX_LABEL: 'Secondary Joint Front Bottom Left',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_DX_LABEL: 'Secondary Joint Front Top Right',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_DX_LABEL: 'Secondary Joint Front Bottom Right',
  GIUNTO_SECONDARIO_FRONTALE_GENERALE_LABEL: 'Secondary Joint Front General',
  GIUNTO_SECONDARIO_LATERALE_ALTO_SX_LABEL: 'Secondary Joint Side Top Left',
  GIUNTO_SECONDARIO_LATERALE_BASSO_SX_LABEL: 'Secondary Joint Side Bottom Left',
  GIUNTO_SECONDARIO_LATERALE_ALTO_DX_LABEL: 'Secondary Joint Side Top Right',
  GIUNTO_SECONDARIO_LATERALE_BASSO_DX_LABEL: 'Secondary Joint Side Bottom Right',
  GIUNTO_SECONDARIO_LATERALE_GENERALE_LABEL: 'Secondary Joint Side General',

  INSTALLATION_INFORMATION_WIZARD_TITLE: 'Installation Information Wizard',
  INSTALLATION_INFORMATION_WIZARD_DESCRIPTION: 'Guided process to collect installation information.',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_SX_QUESTION: 'Please upload a photo of the secondary joint front top left.',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_SX_QUESTION: 'Please upload a photo of the secondary joint front bottom left.',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_DX_QUESTION: 'Please upload a photo of the secondary joint front top right.',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_DX_QUESTION: 'Please upload a photo of the secondary joint front bottom right.',
  GIUNTO_SECONDARIO_FRONTALE_GENERALE_QUESTION: 'Please upload a general photo of the secondary joint front.',
  GIUNTO_SECONDARIO_LATERALE_ALTO_SX_QUESTION: 'Please upload a photo of the secondary joint side top left.',
  GIUNTO_SECONDARIO_LATERALE_BASSO_SX_QUESTION: 'Please upload a photo of the secondary joint side bottom left.',
  GIUNTO_SECONDARIO_LATERALE_ALTO_DX_QUESTION: 'Please upload a photo of the secondary joint side top right.',
  GIUNTO_SECONDARIO_LATERALE_BASSO_DX_QUESTION: 'Please upload a photo of the secondary joint side bottom right.',
  GIUNTO_SECONDARIO_LATERALE_GENERALE_QUESTION: 'Please upload a general photo of the secondary joint side.',

  // My Projects (installer)
  MY_PROJECTS_TITLE: 'My sites',
  MY_PROJECTS_SUBTITLE: 'Select the site you want to work on.',
  MY_PROJECTS_EMPTY: 'You have no assigned sites at the moment.',
  MY_PROJECTS_SEARCH_PLACEHOLDER: 'Search by number, customer or address',
  MY_PROJECTS_SEE_ALL: 'See all',

  // Bottom Navigation
  BOTTOM_NAV_HOME: 'Home',
  BOTTOM_NAV_PRODUCT_HOME: 'Product',
  BOTTOM_NAV_PROJECT: 'Site',
  BOTTOM_NAV_LOGOUT: 'Logout',
  BOTTOM_NAV_LOGIN: 'Login',

  // Wizard Page
  WIZARD_SAVING_ANSWERS: 'Saving your answers...',
  WIZARD_LOADING: 'Loading installation wizard...',
  WIZARD_ANSWER_QUESTION: 'Answer the question',
  WIZARD_YOUR_ANSWER: 'Your answer',
  WIZARD_ENTER_ANSWER: 'Enter your answer',
  WIZARD_SELECT_OPTION: 'Select an option',
  WIZARD_SELECT_OPTIONS: 'Select options',
  WIZARD_TAKE_PHOTO: 'Take Photo',
  WIZARD_CHOOSE_PHOTO: 'Choose Photo',
  WIZARD_REMOVE: 'Remove',
  WIZARD_TAKE_PHOTOS: 'Take Photos',
  WIZARD_CHOOSE_PHOTOS: 'Choose Photos',
  WIZARD_PHOTOS_STAGED: 'photo(s) staged for upload',
  WIZARD_CLEAR_ALL: 'Clear All',
  WIZARD_BACK: 'Back',
  WIZARD_NEXT: 'Next',
  WIZARD_COMPLETE: 'Complete',
  WIZARD_SELECT_WIZARD: 'Select an installation wizard',

  // Language Switcher
  LANGUAGE: 'Language',
  ENGLISH: 'English',
  ITALIAN: 'Italian',

  // Loading Messages
  LOADING_INITIALIZING: 'Initializing...',
  LOADING_REDIRECTING: 'Redirecting to mock dashboard...',
  LOADING_DASHBOARD: 'Loading dashboard...',
  LOADING_PROJECT_DASHBOARD: 'Loading site dashboard...',
  LOADING_COMPLETING_LOGIN: 'Completing login...',
  LOADING_PAGE: 'Loading page...',
  LOADING_PROJECT_DATA: 'Loading site data...',
  LOADING_INSTALLER_DATA: 'Loading installer data...',
  LOADING_FILE_INFO: 'Loading file info...',

  // History Dashboard
  HISTORY_TITLE: 'History',
  HISTORY_RECENT_PROJECTS: 'Recent Sites',
  HISTORY_RECENT_EQUIPMENT: 'Recent Equipment',
  HISTORY_NO_RECENT_PROJECTS: 'No recent sites',
  HISTORY_NO_RECENT_EQUIPMENT: 'No recent equipment',
  HISTORY_PROJECTS_APPEAR_HERE: 'Sites you visit will appear here',
  HISTORY_EQUIPMENT_APPEAR_HERE: 'Equipment you view will appear here',
  HISTORY_CLEAR_HISTORY: 'Clear History',
  HISTORY_CLEAR_CONFIRM: 'Are you sure you want to clear your history?',
  HISTORY_PROJECT_TYPE: 'Site',
  HISTORY_EQUIPMENT_TYPE: 'Equipment',
  HISTORY_UNTITLED_PROJECT: 'Untitled Site',
  HISTORY_EQUIPMENT_DEFAULT: 'Equipment',
  HISTORY_JUST_NOW: 'Just now',
  HISTORY_MINUTES_AGO: 'minutes ago',
  HISTORY_HOUR_AGO: '1 hour ago',
  HISTORY_HOURS_AGO: 'hours ago',
  HISTORY_YESTERDAY: 'Yesterday',
  HISTORY_DAYS_AGO: 'days ago',

  // QR Code Information Card
  QR_INFO_TITLE: 'QR Information',
  QR_INFO_DESCRIPTION: 'QR code and asset information',
  QR_TAG_ID_LABEL: 'Tag ID',
  QR_SERRAMENTO_LABEL: 'Window/Door',
  QR_ASSET_STATUS_LABEL: 'Asset Status',
  QR_PROJECT_LABEL: 'Project',
  QR_POSITION_LABEL: 'Position',
  QR_ARTICLE_LABEL: 'Article',
  QR_NO_DATA: 'No information available',
  QR_LOADING: 'Loading QR information...',
  QR_STATUS_COMPLETED: 'Completed',
  QR_STATUS_EMPTY: 'Empty',
  QR_STATUS_INITIALIZED: 'Initialized',
  QR_STATUS_PROCESSING: 'Processing',
  QR_STATUS_ABORTED: 'Aborted',
  QR_STATUS_UNKNOWN: 'Unknown',

  // Linking Page
  LINKING_PAGE_TITLE: 'QR Code Management',
  LINKING_LOADING_DATA: 'Loading linking data...',
  LINKING_PROJECT_NOT_FOUND: 'Site not found',
  LINKING_PROJECT_ID_REQUIRED: 'Site ID is required',
  LINKING_FAILED_TO_LOAD_DATA: 'Failed to load data',

  // Position Selection (Updated terminology)
  LINKING_SELECT_POSITION: 'Select Window Room',
  LINKING_SELECTED: 'Selected',
  LINKING_PROJECT_POSITIONS: 'Site Window Rooms',
  LINKING_CHOOSE_POSITION: 'Choose a window room...',
  LINKING_FLOOR: 'Floor',
  LINKING_POSITION_DETAILS: 'Window Room Details',
  LINKING_POSITION_NUMBER: 'Window Room',
  LINKING_SEQUENCE_NUMBER: 'Sequence',
  LINKING_DESCRIPTION: 'Description',
  LINKING_ASSET: 'Asset',
  LINKING_DIMENSIONS: 'Dimensions',
  LINKING_NOTES: 'Notes',
  LINKING_MANAGE: 'Manage',

  // Additional terminology consistency updates (KAN-19)
  SITE_MANAGEMENT: 'Site Management',
  SITE_OVERVIEW: 'Site Overview',
  SITE_DETAILS: 'Site Details',

  // QR Tag Selection
  LINKING_SELECT_QR_TAG: 'Select QR Tag',
  LINKING_AVAILABLE_QR_TAGS: 'Available QR Tags',
  LINKING_CHOOSE_QR_TAG: 'Choose a QR tag...',
  LINKING_QR_TAG_DETAILS: 'QR Tag Details',
  LINKING_SERIAL_NO: 'Serial No',
  LINKING_STATUS: 'Status',
  LINKING_SEQUENCE: 'Sequence',
  LINKING_YEAR: 'Year',
  LINKING_CLIENT_CODE: 'Client Code',
  LINKING_ASSET_MODEL: 'Asset Model',

  // Actions
  LINKING_LINK_QR_TAG_TO_POSITION: 'Link QR Tag to Window Room',
  LINKING_UNLINK_QR_TAG: 'Unlink QR Tag',

  // Error Messages
  LINKING_SELECT_BOTH_POSITION_AND_QR_TAG: 'Please select both a window room and a QR tag',
  LINKING_FAILED_TO_LINK_QR_TAG: 'Failed to link QR tag',
  LINKING_FAILED_TO_UNLINK_QR_TAG: 'Failed to unlink QR tag',

  // Success Messages
  LINKING_QR_TAG_LINKED_SUCCESS: 'QR tag successfully linked to window room!',
  LINKING_QR_TAG_UNLINKED_SUCCESS: 'QR tag successfully unlinked from window room!',

  // Linked QR Tags Section
  LINKING_POSITIONS_WITH_LINKED_QR_TAGS: 'Window rooms with Linked QR Tags',
  LINKING_LINKED_QR_TAG: 'Linked QR Tag',
  LINKING_NO_LINKED_QR_TAG: 'QR Tag not linked',
  HEADER_BACK: 'Back',

  // QR Code Management Page - Client Information
  QR_MANAGEMENT_COMMITTENTE_LABEL: 'Contractor:',
  QR_MANAGEMENT_CLIENTE_FINALE_LABEL: 'End Customer:',
  QR_MANAGEMENT_NO_COMMITTENTE: 'Not specified',
  QR_MANAGEMENT_NO_CLIENTE_FINALE: 'Not specified',

  // Updated terminology - Window room instead of Position
  LINKING_SELECT_WINDOW_ROOM: 'Select Window Room',
  LINKING_PROJECT_WINDOW_ROOMS: 'Site Window Rooms',
  LINKING_CHOOSE_WINDOW_ROOM: 'Choose a window room...',
  LINKING_WINDOW_ROOM_DETAILS: 'Window Room Details',
  LINKING_WINDOW_ROOM_NUMBER: 'Window Room',
  LINKING_WINDOW_ROOMS_WITH_LINKED_QR_TAGS: 'Window Rooms with Linked QR Tags',


  "PRODUCT_DETAIL_TITLE": "Product Details",
  "PRODUCT_DETAIL_DESCRIPTION": "General information about the product.",
  "BRAND_LABEL": "Brand",
  "MODEL_LABEL": "Model",
  "MODEL_DESCRIPTION_LABEL": "Model Description",
  "DESCRIPTION_LABEL": "Description",
  "NOTES_LABEL": "Notes",

  "DOCUMENT_DETAIL_TITLE": "Product Documents",
  "DOCUMENT_DETAIL_DESCRIPTION": "All documents related to the product.",
  "TECHNICAL_SHEET_LABEL": "Model Technical Sheet",
  "INSTRUCTION_MANUAL_LABEL": "Use and Maintenance Manual",
  "PRODUCT_PICTURE_LABEL": "Window Frame Picture",
  "INSTALLATION_DOCUMENT_LABEL": "Installation Drawing",
  "CONSTRUCTION_SITE_PLAN_LABEL": "Construction Site Plan",
  "CE_CERTIFICATION_LABEL": "CE Certification",
  "DOP_LABEL": "Declaration of Performance (DOP)",
  "HAZARDOUS_SUBSTANCES_DECLARATION_LABEL": "Hazardous Substances Declaration",

  "POSITION_INFO_TITLE": "Window Room Information",
  "POSITION_INFO_DESCRIPTION": "Details about the product's installation window room.",
  "POSITION_NUMBER_LABEL": "Window Room Number",
  "POSITION_SEQUENCE_LABEL": "Window Room Sequence",
  "FLOOR_LABEL": "Floor",
  "WIDTH_LABEL": "Width (mm)",
  "HEIGHT_LABEL": "Height (mm)",

  "PROJECT_INFO_TITLE": "Site Information",
  "PROJECT_INFO_DESCRIPTION": "Details about the overall site.",
  "PROJECT_NUMBER_LABEL": "Site Number",
  "PROJECT_DATE_LABEL": "Site Date",
  "INSTALLER_INFO_LABEL": "Installer Name",

  "INSTALLATION_GALLERY_TITLE": "Installation Gallery",
  "INSTALLATION_GALLERY_DESCRIPTION": "Photos taken during the installation process.",
  "INSTALLATION_PHOTO_1_LABEL": "Installation Photo 1",
  "INSTALLATION_PHOTO_2_LABEL": "Installation Photo 2",
  "INSTALLATION_PHOTO_3_LABEL": "Installation Photo 3",
  "INSTALLATION_PHOTO_4_LABEL": "Installation Photo 4",
  "INSTALLATION_PHOTO_5_LABEL": "Installation Photo 5",
  "INSTALLATION_PHOTO_6_LABEL": "Installation Photo 6",
  "INSTALLATION_PHOTO_7_LABEL": "Installation Photo 7",
  "INSTALLATION_PHOTO_8_LABEL": "Installation Photo 8",

  "INSTALLATION_WIZARD_TITLE": "Start Image Capture",
  "INSTALLATION_WIZARD_DESCRIPTION": "Take 4 photos of the installation process.",
  "INSTALLATION_PHOTO_1_QUESTION": "Take the first photo of the installation.",
  "INSTALLATION_PHOTO_2_QUESTION": "Take the second photo of the installation.",
  "INSTALLATION_PHOTO_3_QUESTION": "Take the third photo of the installation.",
  "INSTALLATION_PHOTO_4_QUESTION": "Take the final photo of the installation.",
  "INSTALLATION_PHOTO_5_QUESTION": "Take the final photo of the installation.",
  "INSTALLATION_PHOTO_6_QUESTION": "Take the final photo of the installation.",
  "INSTALLATION_PHOTO_7_QUESTION": "Take the final photo of the installation.",
  "INSTALLATION_PHOTO_8_QUESTION": "Take the final photo of the installation.",

  // Project Dashboard
  "MANAGE_LINKINGS_TITLE": "Manage Linkings",
  "MANAGE_LINKINGS_DESCRIPTION": "Configure equipment assignments and connections",

  "PROJECT_DASHBOARD_TITLE": "Site ",
  "PROJECT_DASHBOARD_DESCRIPTION": "Manage all positions and equipment associated with the site.",
  "NO_FILE_UPLOADED": "Document not available",
  "NETWORK_REQUEST_FAILED": "Connection failed. Check your network and try again.",
  "WIZARD_UPLOAD_FAILED": "Photo upload failed. Please try again.",
  "UPLOADING": "Uploading...",
  "UPLOAD_IMAGE": "Upload Picture",
  "UPLOAD_DOCUMENT": "Upload Document",
  "UPLOAD_FILE": "Upload File",
  "PLEASE_UPLOAD_PDF_FILE": "Upload a PDF file",

  // Empty QR Tag
  "QR_TAG_EMPTY_TITLE": "The QR Tag is Empty",
  "QR_TAG_EMPTY_DESCRIPTION": "This QR tag has no data associated with it yet.",
  "QR_TAG_EMPTY_INSTALLER_DESCRIPTION": "This QR tag has no data associated with it yet. Do you want to link it to a position?",
  "LINK_TO_POSITION_BUTTON": "Link to Window Room",
  "PROJECT_INFO": "Site:",

  // Customer information fields
  CUSTOMER_NAME_LABEL: 'Customer Name',
  BUSINESS_NAME_LABEL: 'Business Name',
  CONTRACTOR_LABEL: 'Contractor',
  END_CUSTOMER_LABEL: 'End Customer',
  SITE_ADDRESS_LABEL: 'Site:',

  // Future customer fields (placeholders)
  COMMITTENTE_INFO: 'Contractor Information',
  CLIENTE_FINALE_INFO: 'End Customer Information',

  // Project Dashboard - Window Frame Elements (Updated for KAN-19)
  WINDOW_FRAME_ELEMENTS_TITLE: 'Window frame elements',
  NO_ELEMENTS_ASSIGNED: 'No window frame elements assigned',
  NO_ELEMENTS_ASSIGNED_DESCRIPTION: 'This site has no window frame elements assigned.',

  // Context-specific element terminology (KAN-19)
  ELEMENTS_CONTEXT_WINDOW: 'Window frame elements',
  ELEMENTS_CONTEXT_GENERAL: 'Elements',

  // Element Card Labels
  QR_TAG_SERIAL_LABEL: 'QR Tag Serial:',
  WINDOW_ROOM_IDENTIFIER: 'Window room',
  SERRAMENTO_TYPE_FALLBACK: 'Window Frame',

  // Window Frame Element Identifiers (KAN-19)
  WINDOW_FRAME_ELEMENT_IDENTIFIER: 'Window frame element {{number}}',
  WINDOW_FRAME_ELEMENT_SHORT: 'Window frame element',

  // Construction Site Address Prefix (KAN-19)
  CONSTRUCTION_SITE_PREFIX: 'Construction Site:',

  // Additional Client Information (KAN-19)
  CLIENT_INFORMATION_TITLE: 'Client Information',
  CONTRACTOR_INFORMATION_TITLE: 'Contractor Information',
  END_CUSTOMER_INFORMATION_TITLE: 'End Customer Information',

  // QR Tag Information (KAN-19)
  QR_TAG_INFO_TITLE: 'QR Tag Information',
  QR_TAG_SERIAL_NUMBER: 'QR Tag Serial: {{serialNumber}}',

  // Element Status and Management (KAN-19)
  ELEMENT_STATUS_ASSIGNED: 'Assigned',
  ELEMENT_STATUS_UNASSIGNED: 'Unassigned',
  ELEMENT_MANAGEMENT_TITLE: 'Element Management',

  // Enhanced Window Room Terminology (KAN-19)
  WINDOW_ROOM_OPENING: 'Window room',
  WINDOW_ROOM_ELEMENTS: 'Window room elements',
  WINDOW_ROOM_NUMBER_FORMAT: 'Window room {{number}}',

  // Seller Information Labels
  SELLER_INFO_TITLE: 'Seller Information',
  SELLER_INFO_DESCRIPTION: 'Details about the product seller',
  ADDRESS_LABEL: 'Address',
  SUPPORT_PHONE_LABEL: 'Support Phone',
  SUPPORT_EMAIL_LABEL: 'Support Email',
  WEBSITE_LABEL: 'Website',

  // Position description label
  POSITION_DESCRIPTION_SHORT_LABEL: 'Room Description',
}
